import React from "react"
import { Link } from "gatsby"
import "./card.scss"

const Card = ({ title, subtitle, image, productName, cta, alt, link }) => {
  return (
    <div className="card">
      <div className="card__product">
        {image && <img src={image} alt={alt}></img>}
        {productName && <h4>{productName}</h4>}
      </div>
      {title && <h4 className="bold">{title}</h4>}
      <p>{subtitle}</p>
      <Link to={link}>
        <div className="highlight bold">{cta ? cta : "Explore"}</div>
      </Link>
      <hr />
    </div>
  )
}

export default Card
